<color-picker [(value)]="value" [(format)]="format"></color-picker>